import {Pipe, PipeTransform} from '@angular/core';
import {MimeTypesEnum} from '../enums';

@Pipe({
    name: 'returnMimetypePipe',
    standalone: true,
    pure: true,
})
export class ReturnMimetypePipe implements PipeTransform {

  transform(value: string): string {
    switch (value) {
      case MimeTypesEnum.ApplicationPdf:
        return '.pdf';
      case MimeTypesEnum.ApplicationRtf:
        return '.rtf';
      default: return MimeTypesEnum.ApplicationPdf;
    }
  }
}
